// @flow

import type { ObjectType } from '@types/misc';

type TProps = {
  style: ObjectType
};

export default class Loading extends React.Component<TProps> {
  static defaultProps = { style: {} };

  render() {
    return (
      <svg
        style={this.props.style}
        width='40px'
        height='40px'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 100 100'
        preserveAspectRatio='xMidYMid'
        className='uil-ring'
      >
        <rect x='0' y='0' width='100' height='100' fill='none' className='bk' />
        <circle
          cx='50'
          cy='50'
          r='45'
          strokeDasharray='162.57741982327178 120.1659189998096'
          stroke='#194979'
          fill='none'
          strokeWidth='10'
        >
          <animateTransform
            attributeName='transform'
            type='rotate'
            values='0 50 50;180 50 50;360 50 50;'
            keyTimes='0;0.5;1'
            dur='1s'
            repeatCount='indefinite'
            begin='0s'
          />
        </circle>
      </svg>
    );
  }
}
